import { Grid, IconButton, List, ListItem, ListItemText, Stack, styled, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { CheckboxComponent, DateField, TextFieldComponent } from "../external/ensolvers-core-frontend-mui/components/Common/FormComponents";
import GenericForm from "../external/ensolvers-core-frontend-mui/components/Common/GenericForm";
import { Documentation } from "../models/Documentation";
import Timeoff from "../models/Timeoff";
import CustomDateFnsUtils from "../utils/CustomDateFnsUtils";
import SearchIcon from "@mui/icons-material/Search";
import { DateFieldComponent } from "./DatePicker";
import { useStyles } from "./Main/formStyles";
import { ColorUtils } from "../utils/ColorUtils";

interface Props {
  viewTimeoff: Timeoff | undefined;
  selectedFiles: Documentation[];
  onClose: () => void;
}

export default function TimeoffViewDialog(props: Props) {
  const customStyles = useStyles();
  const getDocumentationList = () => {
    return (
      <List dense>
        {props.selectedFiles.map((item: Documentation, index: number) => (
          <ListItem
            key={index}
            secondaryAction={
              <>
                {item.url && (
                  <IconButton
                    edge="end"
                    aria-label="view"
                    onClick={() => {
                      window.open(item.url, "_blank");
                    }}
                  >
                    <SearchIcon />
                  </IconButton>
                )}
              </>
            }
          >
            <ListItemText primary={item?.name?.length > 60 ? item?.name?.substring(0, 60).concat("...") : item.name || item.url} />
          </ListItem>
        ))}
      </List>
    );
  };

  if (!props.viewTimeoff) {
    return null;
  }

  return (
    <GenericForm<Timeoff>
      headerStyles={{ color: ColorUtils.ENSOLVERS_ORANGE_REBRANDING, marginBottom:-10, marginTop:10 }}
      buttonStyles={{ marginRight: 20, color: 'white', backgroundColor: ColorUtils.ENSOLVERS_ORANGE_REBRANDING, marginBottom: 10 }}
      cancelButtonStyles={{ color: ColorUtils.ENSOLVERS_ORANGE_REBRANDING, border: `1px solid ${ColorUtils.ENSOLVERS_ORANGE_REBRANDING}`, marginBottom: 10 }}
      dialogStyles={customStyles.root}      
      dialog={true}
      open={!!props.viewTimeoff}
      instance={props.viewTimeoff}
      title={`${props.viewTimeoff.requester.firstName} ${props.viewTimeoff.requester.lastName} - Time Off`}
      onSave={() => props.onClose()}
      dialogCustomSubmitMessage={"Close"}
      hideCancel={true}
      disableBackdropClick
      renderContent={(register, errors, control) => (
        <>
          <TextFieldComponent propertyName={"type"} label="Time Off Type" internalProps={{ autoFocus: true }} readOnly />

          <DateFieldComponent
            control={control}
            register={register}
            errors={errors}
            propertyName={"shortStartDate"}
            label="Start Date"
            readOnly
            required={true}
            utils={CustomDateFnsUtils}
            toUTC
          />

          <DateFieldComponent
            control={control}
            register={register}
            errors={errors}
            propertyName={"shortEndDate"}
            label="End Date"
            readOnly
            required={true}
            utils={CustomDateFnsUtils}
            toUTC
          />

          <CheckboxComponent
            control={control}
            register={register}
            errors={errors}
            propertyName={"halfDay"}
            label="Half day"
            required={false}
            readOnly={true}
          />

          <Grid>
            {props.selectedFiles.length > 0 ? (
              getDocumentationList()
            ) : (
              <label style={{ display: "block", marginTop: "1.0em" }}>{"There is no documentation attached"}</label>
            )}
          </Grid>
        </>
      )}
    />
  );
}
